export default "__VITE_ASSET__ea689857__"